<script>
  import clsx from "clsx";
  import { nanoid } from "nanoid";

  let className = "my-4";

  export let options = {};
  export { className as class };
  export let required = false;
  export let row = false;
  export let group;
  export let change;

  const name = "radio-" + nanoid();

  const isArray = Array.isArray(options);
</script>

<div class={clsx(className, "flex flex-wrap gap-x-4 gap-y-2", row && "flex-col")}>
  {#each isArray ? options : Object.keys(options) as item}
    <label class="flex cursor-pointer items-center gap-x-2">
      <input class="form-radio" {name} type="radio" {required} value={isArray ? item.value : item} bind:group on:change={change} />
      {isArray ? item.label || item.value : options[item]}
      {#if required}<span class="text-red-700">*</span>{/if}
    </label>
  {/each}
</div>
